"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.default = exports.PulseNotificationsTab = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var NotificationsActions = _interopRequireWildcard(require("../../store/actions/actions"));

var NotificationsSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _IllustratedMessage = _interopRequireDefault(require("@react/react-spectrum/IllustratedMessage"));

var _NoContent = _interopRequireDefault(require("../../resources/NoContent.js"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseNotificationsTab"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _SettingsService = _interopRequireDefault(require("../../service/SettingsService"));

require("./PulseNotificationsTab.scss");

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var PulseNotificationsTab =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseNotificationsTab, _Component);

  function PulseNotificationsTab(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PulseNotificationsTab);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseNotificationsTab).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loadMore: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScroll",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(e) {
        var bottom;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

                if (!(bottom && !_this.props.hasTimelineEndReached)) {
                  _context.next = 8;
                  break;
                }

                if (_this.state.loadMore) {
                  _context.next = 8;
                  break;
                }

                _this.metrics.event("flyout.loadMoreNotifications.onScroll", {
                  region: window.config && window.config.region
                });

                _this.setState({
                  loadMore: true
                });

                _context.next = 7;
                return _this.props.dispatch(NotificationsActions.fetchTimeline({
                  to: _this.props.previousPageTimestamp
                }));

              case 7:
                _this.setState({
                  loadMore: false
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderPulseNotificationMessage", function (pulseMessageObject) {
      return _react.default.createElement(_PulseNotificationMessageWrapper.default, {
        pulseMessageObject: pulseMessageObject,
        locale: _this.props.locale,
        isFloatingAlert: false,
        showError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSectionNotifications", function (notifications) {
      return notifications.length > 0 && notifications.map(function (entry) {
        return _react.default.createElement("li", {
          key: entry
        }, _this.renderPulseNotificationMessage(_this.props.notificationsById[entry]));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNewNotificationButton", function () {
      _this.metrics.event("flyout.newNotification.render", {
        region: window.config && window.config.region
      });

      var newCount = _this.justArrivedNotificationCount;
      return _react.default.createElement(_Button.default, {
        variant: "cta",
        className: "pulse-button-new-notifications",
        onClick: function onClick() {
          _this.props.dispatch({
            type: types.SET_FLYOUT_LAST_OPEN_TIMESTAMP,
            payload: _this.props.serverTime
          });
        }
      }, newCount > 1 ? _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "newNotifications",
        defaultMessage: "{newCount} new notifications",
        values: {
          newCount: newCount
        },
        description: "new notifications (Multiple)"
      }) : _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "newNotification",
        defaultMessage: "{newCount} new notification",
        values: {
          newCount: newCount
        },
        description: "new notification (Single)"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNotifications", function () {
      var _this$props = _this.props,
          newNotifications = _this$props.newNotifications,
          earlierNotifications = _this$props.earlierNotifications;
      var reactElements = [];

      if (!_this.props.isFlyoutOpen) {
        if (newNotifications.length > 0) {
          reactElements.push(_this.renderNewSectionHeader(newNotifications.length));
          reactElements.push(_this.renderSectionNotifications(newNotifications));
          earlierNotifications.length > 0 && reactElements.push(_this.renderEarlierSectionHeader());
        }

        reactElements.push(_this.renderSectionNotifications(earlierNotifications));
      } else {
        var newCount = 0;
        _this.justArrivedNotificationCount = 0;

        if (newNotifications.length > 0) {
          //only add notifications that got received before the lastOpenTimestamp
          newNotifications.forEach(function (element) {
            var notification = _this.props.notificationsById[element];

            if (notification.sortedTimestamp < _this.props.lastOpenTimestamp) {
              reactElements.push(_react.default.createElement("li", {
                key: element,
                className: "newmessage"
              }, " ", _this.renderPulseNotificationMessage(notification), " "));
              newCount++;
            } else {
              _this.justArrivedNotificationCount++;
            }
          });

          if (newCount > 0) {
            reactElements.unshift(_this.renderNewSectionHeader(newCount));
            earlierNotifications.length > 0 && reactElements.push(_this.renderEarlierSectionHeader());
          }
        }

        reactElements.push(_this.renderSectionNotifications(earlierNotifications));
      }

      return reactElements;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLoadingUI", function () {
      return _react.default.createElement("div", {
        className: "pulse-no-notifications-message"
      }, _react.default.createElement(_Wait.default, {
        centered: true
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNoNotifications", function () {
      return _react.default.createElement(_IllustratedMessage.default, {
        className: "pulse-no-notifications-message",
        description: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
          messageId: "noNotifications",
          defaultMessage: "You have no notifications",
          description: "No Notifications"
        }),
        illustration: _react.default.createElement(_NoContent.default, null)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNotificationPane", function () {
      if (!_this.props.notificationsById) {
        return _this.renderLoadingUI();
      }

      if ((0, _isEmpty2.default)(_this.props.newNotifications) && (0, _isEmpty2.default)(_this.props.earlierNotifications)) return _this.renderNoNotifications();
      return _react.default.createElement("ul", {
        className: "pulse-notifications-tab-list"
      }, _this.renderNotifications(), _this.state.loadMore ? _react.default.createElement("div", {
        className: "pulse-notifications-tab-load-more-area"
      }, " ", _react.default.createElement(_Wait.default, null), " ") : null);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNewSectionHeader", function (length) {
      var maxDigits = 1,
          TEN = 10,
          maxValue = Math.pow(TEN, maxDigits) - 1;
      var newCount = length > maxValue ? "".concat(maxValue, "+") : "".concat(length);
      return _react.default.createElement("div", {
        className: "section-header",
        key: "new"
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "New",
        defaultMessage: "NEW",
        description: "New Header"
      }), " (".concat(newCount, ") "));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEarlierSectionHeader", function () {
      return _react.default.createElement("div", {
        className: "section-header earlier-section",
        key: "earlier"
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "Earlier",
        defaultMessage: "EARLIER",
        description: "Earlier Header"
      }));
    });
    _this.metrics = _metrics.default.create("exc.pulse.components.tabs.PulseNotificationsTab");
    return _this;
  }

  (0, _createClass2.default)(PulseNotificationsTab, [{
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var timeNow;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timeNow = this.props.serverTime;
                _context2.next = 3;
                return this.props.dispatch({
                  type: types.SET_LAST_USER_CLICK_TIMESTAMP,
                  payload: timeNow
                });

              case 3:
                _context2.next = 5;
                return this.props.dispatch({
                  type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
                  payload: timeNow
                });

              case 5:
                _context2.next = 7;
                return (0, _SettingsService.default)().updateUserSettings({
                  lastClickTimestamp: timeNow
                });

              case 7:
                _context2.next = 9;
                return (0, _SettingsService.default)().updateUserSettings({
                  lastNotificationSeenTimestamp: timeNow
                });

              case 9:
                window.removeEventListener('scroll', this.handleScroll, false);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_adobeIntlReact.default, {
        locale: this.props.locale,
        localeData: localizationStrings
      }, _react.default.createElement("div", {
        className: "pulse-notifications-tab pulse-notifications-tab-container",
        onScroll: this.handleScroll
      }, this.renderNotificationPane(), this.justArrivedNotificationCount > 0 ? this.renderNewNotificationButton(this.justArrivedNotificationCount) : null));
    }
  }]);
  return PulseNotificationsTab;
}(_react.Component);

exports.PulseNotificationsTab = PulseNotificationsTab;

function mapStateToProps(state) {
  return {
    lastClickTimestamp: NotificationsSelectors.getLastClickTimestamp(state),
    previousPageTimestamp: NotificationsSelectors.getPreviousPageTimestamp(state),
    notificationsById: NotificationsSelectors.getNotificationsById(state),
    newNotifications: NotificationsSelectors.getNewNotifications(state),
    earlierNotifications: NotificationsSelectors.getEarlierNotifications(state),
    locale: NotificationsSelectors.getLocale(state),
    lastOpenTimestamp: NotificationsSelectors.getLastOpenTimestamp(state),
    isFlyoutOpen: NotificationsSelectors.isFlyoutOpen(state),
    hasTimelineEndReached: NotificationsSelectors.hasTimelineEndReached(state),
    serverTime: NotificationsSelectors.getServerTime(state)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(PulseNotificationsTab);

exports.default = _default;